import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { homepageWins } from "../../data/caseResults";
import { resultsDisclaimer, RESULTS_PATH } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function MoreWins() {
  return <section aria-labelledby="more-wins-title" className="border-b border-line bg-ivory" data-id="element-252" data-mp="2i2xf3l5opebm">
      <div className="page-container py-14 md:py-20" data-id="element-253" data-mp="2d2i2wwx52cv8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between lg:gap-10" data-id="element-254" data-mp="1pbm6tnlngvi6">
          <div className="max-w-measure" data-id="element-255" data-mp="1lbbyw5earv0o">
            <p className="eyebrow text-label font-bold text-crimson" data-id="element-256" data-mp="1lcd967nhodhc">Results for Michigan riders</p>
            <h2 id="more-wins-title" className="section-title mt-3 text-h2-m font-extrabold text-ink md:text-h2" data-id="element-257" data-mp="1zbms3f32xlp0">
              More cases. Real outcomes.
            </h2>
          </div>
          <SiteLink path={RESULTS_PATH} className="inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-ink underline underline-offset-4" data-id="element-258" data-mp="3anxcoy7o6bid">
            View More
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-259" data-mp="1s1s098ib8zj0" />
          </SiteLink>
        </div>

        <p className="mt-5 max-w-measure text-body-m text-slate md:text-body" data-id="element-260" data-mp="1x0lbsve1eggj">{resultsDisclaimer}</p>

        <div className="mt-8 grid gap-5 lg:grid-cols-3" data-id="element-261" data-mp="221iud92ylcik">
          {homepageWins.map(result => <article key={result.id} className="case-card flex h-full flex-col border border-line border-t-4 border-t-crimson bg-white p-6 md:p-8" data-id="element-262" data-mp="26zkd1swh39ti">
              <p className="text-[40px] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-[48px]" data-id="element-263" data-mp="1eb5bo969kq0n">
                {result.figure}
              </p>
              <p className="mt-2 text-label font-bold text-crimson" data-id="element-264" data-mp="1j96vwxffevdp">{result.outcome}</p>
              <h3 className="mt-6 text-h3 font-bold text-ink" data-id="element-265" data-mp="1o2rjrwnb28z6">{result.title}</h3>
              <p className="mt-3 text-body-m text-slate md:text-body" data-id="element-266" data-mp="qkrj8hjrop5j">{result.summary}</p>
              <SiteLink path={result.storyPath || `${RESULTS_PATH}#${result.id}`} className="mt-auto inline-flex min-h-[48px] items-center gap-2 pt-6 text-label font-bold text-ink underline underline-offset-4" data-id="element-267" data-mp="vk426r7ipc2u">
                {result.storyLabel || "View the published summary"}
                <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-268" data-mp="x9honkn8twnr" />
              </SiteLink>
            </article>)}
        </div>
      </div>
    </section>;
}